import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const CommentsSectionQuery: GraphQLTaggedNode = graphql`
	query CommentsSectionQuery($offset: String, $first: Long, $contentId: ID!) @allowHigherTimeout {
		comments(
			pageId: $contentId
			type: FOOTER
			depth: ALL
			confluenceCommentFilter: { commentState: UNRESOLVED, commentType: FOOTER }
			first: $first
			after: $offset
		) {
			totalCount
			pageInfo {
				hasNextPage
				endCursor
			}
			edges {
				cursor
				node {
					id
					ancestors {
						id
					}
					author {
						type
						displayName
						profilePicture {
							path
						}
						... on KnownUser {
							accountId
							permissionType
						}
					}
					body(representation: ATLAS_DOC_FORMAT) {
						value
					}
					contentStatus
					createdAt {
						value
					}
					createdAtNonLocalized
					links {
						webui
					}
					location {
						type
						... on InlineComment {
							inlineMarkerRef
							inlineText
							inlineResolveProperties {
								isDangling
								resolvedTime
								resolvedFriendlyDate
								resolvedUser
								resolved
							}
						}
						... on FooterComment {
							commentResolveProperties {
								resolvedTime
								resolvedFriendlyDate
								resolvedUser
								resolved
							}
						}
					}
					parentId
					permissions {
						isEditable
						isRemovable
						isResolvable
					}
					version {
						friendlyWhen
						number
						when
						by {
							type
							displayName
							... on KnownUser {
								accountId
							}
						}
					}
					reactionsSummary(pageId: $contentId, contentType: "page", childType: "comment") {
						ari
						containerAri
						reactionsCount
						reactionsSummaryForEmoji {
							id
							emojiId
							count
							reacted
						}
					}
				}
			}
		}
		content(id: $contentId) {
			nodes {
				subType
				id
				operations {
					operation
					targetType
				}
				space {
					id
					homepageId
				}
				type
				history {
					createdBy {
						... on KnownUser {
							accountId
						}
					}
				}
			}
		}
		user: confluence_atlassianUser(current: true) {
			displayName
			photos {
				isPrimary
				value
			}
			id
		}
	}
`;
export const CommentsSectionWithoutReactionsQuery: GraphQLTaggedNode = graphql`
	query CommentsSectionQueryWithoutReactionsQuery($offset: String, $first: Long, $contentId: ID!) {
		comments(
			pageId: $contentId
			type: FOOTER
			depth: ALL
			confluenceCommentFilter: { commentState: UNRESOLVED, commentType: FOOTER }
			first: $first
			after: $offset
		) {
			totalCount
			pageInfo {
				hasNextPage
				endCursor
			}
			edges {
				cursor
				node {
					id
					ancestors {
						id
					}
					author {
						type
						displayName
						profilePicture {
							path
						}
						... on KnownUser {
							accountId
							permissionType
						}
					}
					body(representation: ATLAS_DOC_FORMAT) {
						value
					}
					contentStatus
					createdAt {
						value
					}
					createdAtNonLocalized
					links {
						webui
					}
					location {
						type
						... on InlineComment {
							inlineMarkerRef
							inlineText
							inlineResolveProperties {
								isDangling
								resolvedTime
								resolvedFriendlyDate
								resolvedUser
								resolved
							}
						}
						... on FooterComment {
							commentResolveProperties {
								resolvedTime
								resolvedFriendlyDate
								resolvedUser
								resolved
							}
						}
					}
					parentId
					permissions {
						isEditable
						isRemovable
						isResolvable
					}
					version {
						friendlyWhen
						number
						when
						by {
							type
							displayName
							... on KnownUser {
								accountId
							}
						}
					}
				}
			}
		}
		content(id: $contentId) {
			nodes {
				subType
				id
				operations {
					operation
					targetType
				}
				space {
					id
					homepageId
				}
				type
				history {
					createdBy {
						... on KnownUser {
							accountId
						}
					}
				}
			}
		}
		user: confluence_atlassianUser(current: true) {
			displayName
			photos {
				isPrimary
				value
			}
			id
		}
	}
`;
